// extracted by mini-css-extract-plugin
export var btn = "login-module--btn--97a9c";
export var buttonWrapper = "login-module--button-wrapper--a3fbc";
export var headingText = "login-module--heading-text--1fdc0";
export var iconWrapper = "login-module--icon-wrapper--9ca55";
export var innerWrapper = "login-module--inner-wrapper--4777d";
export var logInContainer = "login-module--log-in-container--d7537";
export var logInMobileSizeOnlyContainer = "login-module--log-in-mobile-size-only-container--9d6c7";
export var loginContentText = "login-module--login-content-text--4c782";
export var outerWrapper = "login-module--outer-wrapper--7c802";